<template>

  <el-form :model="form" :rules="rules" ref="form">

    <el-form-item label="Capital Social" prop="capitalSocial" :rules="{ required: true, message: 'O capital social é obrigatório', trigger: 'blur' }  ">
      <em>Valor investido para abertura e funcionamento da empresa</em>
      <div class="el-input el-input-group el-input-group--prepend">
        <div class="el-input-group__prepend">R$</div>
        <input type="text" v-model="form.capitalSocial" v-mask="'money'" autocomplete="off" class="el-input__inner" />
      </div>
    </el-form-item>

    <h3>Participação Societária</h3>

    <div v-for="(socio, index) in form.socios">

      <h4>Sócio {{ index+1 }} <el-button type="danger" @click.prevent="removePartner(socio)" icon="delete" v-if="form.socios.length > 1">Deletar</el-button></h4>

      <el-form-item>

        <el-col :span="16">
          <el-form-item label="Nome" :prop="'socios.' + index + '.nome'" :rules="{ required: true, message: 'O nome do sócio é obrigatório', trigger: 'blur' }">
            <el-input v-model="socio.nome"></el-input>
          </el-form-item>
        </el-col>

        <el-col :offset="1" :span="7">
          <el-form-item :prop="'socios.' + index + '.socioAdministrador'" :rules="{ validator: validateUniqueAdministrator, trigger: 'change'}">
            <label :for="`socios.${index}.comunhaoDeBens`" class="el-form-item__label" style="width: 100%; text-align: left;">Sócio Administrador?</label>
            <el-switch active-text="Sim" inactive-text="Não" active-color="#13ce66" inactive-color="#ff4949" v-model="socio.socioAdministrador" @change="updateAdministrator(socio)">Sócio Administrador?</el-switch>
          </el-form-item>
        </el-col>

      </el-form-item>

      <el-form-item>

        <el-col :span="16">
          <el-form-item :prop="'socios.' + index + '.participacaoSocietaria'">
            <label :for="`socios.${index}.participacaoSocietaria`" class="el-form-item__label" style="float: none; text-align: left;">Participação Societária em %?</label>
            <el-slider v-model="socio.participacaoSocietaria" show-input></el-slider>
          </el-form-item>
        </el-col>

        <el-col :offset="1" :span="6">
          <el-form-item :prop="'socios.' + index + '.retiraProLabore'">
            <label :for="`socios.${index}.retiraProLabore`" class="el-form-item__label" style="width: 100%; text-align: left;">Retira Pró-Labore?</label>
            <el-switch active-text="Sim" inactive-text="Não" active-color="#13ce66" inactive-color="#ff4949" v-model="socio.retiraProLabore" @change="alertProLabore"></el-switch>
          </el-form-item>
        </el-col>

      </el-form-item>

      <el-form-item>

        <el-col :span="8">

          <el-form-item label="Data de Nascimento" :prop="'socios.' + index + '.dataNascimento'" :rules="{ type: 'date', required: true, message: 'A data de nascimento é obrigatória', trigger: 'blur'}">
            <el-date-picker type="date" v-model="socio.dataNascimento" format="dd/MM/yyyy" style="width: 100%;" placeholder="DD/MM/AAAA"></el-date-picker>
          </el-form-item>

        </el-col>

        <el-col :offset="1" :span="7">

          <el-form-item label="Estado Cívil" :prop="'socios.' + index + '.estadoCivil'">
            <el-select v-model="socio.estadoCivil" @change="updateCommunity(socio.estadoCivil, index)" style="width: 100%;">
              <el-option v-for="estado in estadosCiveis" :key="estado" :label="estado" :value="estado">
              </el-option>
            </el-select>
          </el-form-item>

        </el-col>

        <el-col :offset="1" :span="7">

          <el-form-item :prop="'socios.' + index + '.comunhaoDeBens'">
            <label :for="`socios.${index}.comunhaoDeBens`" class="el-form-item__label" style="width: 100%; text-align: left;">Comunhão de Bens?</label>
            <el-switch active-text="Sim" inactive-text="Não" active-color="#13ce66" inactive-color="#ff4949" v-model="socio.comunhaoDeBens" :disabled="socio.estadoCivil !== 'Casado'"></el-switch>
          </el-form-item>

        </el-col>

      </el-form-item>

      <el-form-item>

        <el-col :span="8">

          <el-form-item label="Profissão" :prop="'socios.' + index + '.profissao'">
            <el-input v-model="socio.profissao"></el-input>
          </el-form-item>

        </el-col>

        <el-col :offset="1" :span="7">

          <el-form-item label="Nacionalidade" :prop="'socios.' + index + '.nacionalidade'">
            <el-input v-model="socio.nacionalidade"></el-input>
          </el-form-item>

        </el-col>

        <el-col :offset="1" :span="7">

          <el-form-item label="Naturalidade" :prop="'socios.' + index + '.naturalidade'">
            <el-input v-model="socio.naturalidade"></el-input>
          </el-form-item>

        </el-col>

      </el-form-item>

      <el-form-item>

        <el-col :span="8">

          <el-form-item label="RG" :prop="'socios.' + index + '.rg'">
            <el-input v-model="socio.rg"></el-input>
          </el-form-item>

        </el-col>

        <el-col :offset="1" :span="7">

          <el-form-item
            label="CPF"
            :key="socio.key"
            :prop="'socios.' + index + '.cpf'"
            :rules="[
              { required: true, message: 'O CPF é obrigatório', trigger: 'blur' },
              { validator: validateCpf, trigger: 'blur'}
            ]"
            >
            <div class="el-input">
              <input type="text" v-model="socio.cpf" placeholder="999.999.999-99" v-mask="'999.999.999-99'" class="el-input__inner" />
            </div>
          </el-form-item>

        </el-col>

        <el-col :offset="1" :span="7">

          <el-form-item label="Título de Eleitor" :prop="'socios.' + index + '.tituloEleitor'">
            <el-input v-model="socio.tituloEleitor"></el-input>
          </el-form-item>

        </el-col>

      </el-form-item>

    </div>

    <el-form-item>
      <el-button type="success" @click="addPartner">Adicionar Sócio</el-button>
    </el-form-item>

  </el-form>

</template>

<script>
import AwesomeMask from 'awesome-mask'
import { validaCpf } from '../../validators/cpf.js'

export default {
  props: ['form'],

  directives: {
    'mask': AwesomeMask
  },

  data () {
    return {
      estadosCiveis: [
        'Solteiro',
        'Casado',
        'Divorciado',
        'Viuvo'
      ],
      rules: {
        capitalSocial: [
          { required: true, message: 'O valor do capital social é obrigatório', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    validateCpf: (rule, value, callback, source) => validaCpf(rule, value, callback, source),

    validateUniqueAdministrator (rule, value, callback) {
      const hasntAdministrator = this.form.socios.every(element => element.socioAdministrador === false)

      if (hasntAdministrator) {
        callback(new Error('Um dos sócios deve ser o administrador'))
      } else {
        callback()
      }
    },

    alertProLabore (value) {
      if (value === true) {
        this.$message({ type: 'info', message: 'Importante: Para ficar ISENTO do Recolhimento do INSS do sócio, alterar para a opção NÃO.' })
      }
    },

    updateAdministrator (el) {
      this.form.socios.filter(element => element !== el).map(socio => {
        socio.socioAdministrador = false
      })
    },

    updateCommunity (estado, socio) {
      if (estado !== 'Casado') {
        this.form.socios[socio].comunhaoDeBens = false
      }
    },

    removePartner (item) {
      this.form.socios.splice(this.form.socios.indexOf(item), 1)
    },

    addPartner () {
      this.form.socios.push({
        key: Date.now(),
        nome: '',
        dataNascimento: '',
        estadoCivil: 'Solteiro',
        comunhaoDeBens: false,
        profissao: '',
        nacionalidade: '',
        naturalidade: '',
        rg: '',
        cpf: '',
        tituloEleitor: '',
        participacaoSocietaria: 0,
        retiraProLabore: false,
        socioAdministrador: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContratoSocial.vue?de163622